import '../routes/publicPath';

import 'consumerweb-shim';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React, { Suspense } from 'react';
import { Route, Switch, Router } from 'react-router-dom';
import history from '../routes/configureHistory';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import getStore from '../buttons/store/configureStore';
import '../utility/csrf';
import Spinner from './spinner/Spinner';
import { setContainerMarginsBefore } from '../buttons/utils/headerUtils';
import { reactLazyPreload } from '../utility/lazyLoader';
import { lazy as reactLazy } from 'react';
import FallbackSpinner from './common/FallbackSpinner';
import ButtonFactoryWizardV3 from '../buttons/componentsV3/ButtonFactoryWizardV3';
import '../../css/ppvx-buttonFactory.less';

setContainerMarginsBefore();
const store = getStore();

const MarketingHeader = reactLazy(() =>
  import(
    /* webpackChunkName: "MarketingHeader" */ './marketingHeader/MarketingHeader'
  )
);

const PartnerButtonsV3 = reactLazyPreload(() =>
  import(
    /* webpackChunkName: "PartnerButtonsV3" */ '../buttons/componentsV3/partner/partnerButtons'
  )
);

const PartnerTermsMerchantV3 = reactLazyPreload(() =>
  import(
    /* webpackChunkName: "PartnerTermsMerchantV3" */ '../buttons/componentsV3/partner/partnerTermsMerchant'
  )
);

const ButtonOverviewV3 = reactLazyPreload(() =>
  import(
    /* webpackChunkName: "ButtonOverviewV3" */ '../buttons/componentsV3/buttonManager/buttonOverview/buttonOverview'
  )
);

const ButtonManagerV3 = reactLazyPreload(() =>
  import(
    /* webpackChunkName: "ButtonManagerV3" */ '../buttons/componentsV3/buttonManager/buttonManager'
  )
);

const PartnerTermsCustomerV3 = reactLazyPreload(() =>
  import(
    /* webpackChunkName: "PartnerTermsCustomerV3" */ '../buttons/componentsV3/partner/partnerTermsCustomer'
  )
);

const App = () => {
  return (
    <div>
      <Router history={history}>
        <Suspense fallback={<FallbackSpinner />}>
          <Switch>
            <Route
              exact
              path="/donate/buttons/partner"
              component={PartnerButtonsV3}
            />
            <Route
              exact
              path="/donate/buttons/partner/terms/merchant"
              component={PartnerTermsMerchantV3}
            />
            <Route
              exact
              path="/donate/buttons/partner/terms/customer"
              component={PartnerTermsCustomerV3}
            />
            <Route
              exact
              path="/donate/buttons/manage/:buttonId"
              component={ButtonOverviewV3}
            />
            <Route
              exact
              path="/donate/buttons/manage"
              component={ButtonManagerV3}
            />
            <Route
              exact
              path="/donate/buttons/create"
              component={ButtonFactoryWizardV3}
            />
            <Route
              exact
              path="/donate/buttons/login"
              component={ButtonFactoryWizardV3}
            />
            <Route
              exact
              path="/donate/buttons/:buttonId/edit"
              component={ButtonFactoryWizardV3}
            />
            <Route
              exact
              path="/donate/buttons/:buttonId/duplicate"
              component={ButtonFactoryWizardV3}
            />
            <Route
              exact
              path="/donate/buttons/:buttonId"
              component={ButtonOverviewV3}
            />
            <Route
              exact
              path="/donate/buttons"
              component={ButtonFactoryWizardV3}
            />
          </Switch>
        </Suspense>
      </Router>
    </div>
  );
};

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <App />
    </Router>
  </Provider>,
  document.getElementById('react-buttons-container')
);

if (document.getElementById('marketing-header-container')) {
  ReactDOM.render(
    <Provider store={store}>
      <Router history={history}>
        <Suspense fallback={<div />}>
          <div>
            <Route path="/" component={MarketingHeader} />
          </div>
        </Suspense>
      </Router>
    </Provider>,
    document.getElementById('marketing-header-container')
  );
}

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <div>
        <Route path="/" component={Spinner} />
      </div>
    </Router>
  </Provider>,
  document.getElementById('button-factory-spinner')
);
